export default {
  /**
   * Không hiển thị
   */
  NotShow: 0,
  /**
   * Hiển thị thông báo với đơn vị đăng ký kết nối DVC
   */
  ShowUseDVCNotification: 1,

  /**
   * Hiển thị thông báo với đơn vị không đăng ký kết nối DVC
   */
  ShowNotUseDVCNotification: 2,
};
